import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0f00] py-12 px-4" data-id="element-378">
      <div className="max-w-5xl mx-auto" data-id="element-379">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-380">
          <div data-id="element-381">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-382">
              +500
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-383">
              entrenadores confían
            </div>
          </div>
          <div data-id="element-384">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-385">
              6+6
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-386">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-387">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-388">
              4.9/5
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-389">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-390">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-391">🌎</div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-392">
              Argentina + toda Latinoamérica
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-393">
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-394">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-395">
              MR
            </div>
            <div data-id="element-396">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-397">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-398">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para todos mis grupos. Nunca más llego al
                gym sin saber qué voy a dar."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-399">
                — Marcos R., Buenos Aires | Entrenador de Gym de Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-400">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-401">
              JG
            </div>
            <div data-id="element-402">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-403">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-404">
                "Las clases con progresión real bimestral cambiaron todo. Mis
                alumnos intermedios mejoraron más en 2 meses que en todo el año
                anterior. El sistema de potencia del Tomo 3 es único."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-405">
                — Jorge G., Rosario | Instructor de Boxeo Recreativo
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-406">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-407">
              SV
            </div>
            <div data-id="element-408">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-409">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-410">
                "Adapto la misma clase a 3 niveles distintos en 5 minutos. Antes
                me llevaba horas inventar qué hacer. Con el Método 3 Carriles
                del Bono 1, todos trabajan al mismo tiempo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-411">
                — Sofía V., Córdoba | Profesora de Educación Física
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}